// The classes of a document body, shared by the live editor, the static view
// shown before sync and published static HTML. Copying them into one place only
// brings back "the look changes the moment the view switches".
//
// Size, line height and color are not here (they differ by place; the caller adds them).

/** The look of a markdown body. */
export const MARKDOWN_BODY_CLASS = `[&_.tiptap]:outline-none
  [&_pre]:my-2 [&_pre]:overflow-x-auto [&_pre]:rounded-md [&_pre]:border [&_pre]:border-[color:var(--color-border-soft)] [&_pre]:bg-[color:var(--color-hover)] [&_pre]:p-3
  [&_code]:rounded [&_code]:bg-[color:var(--color-code-bg)] [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[0.9em]
  [&_pre_code]:bg-transparent [&_pre_code]:p-0
  [&_h1]:mb-3 [&_h1]:mt-6 [&_h1]:text-2xl [&_h1]:font-semibold
  [&_h2]:mb-2 [&_h2]:mt-5 [&_h2]:text-xl [&_h2]:font-semibold
  [&_h3]:mb-2 [&_h3]:mt-4 [&_h3]:text-lg [&_h3]:font-semibold
  [&_p]:my-2
  [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5
  [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5
  [&_blockquote]:my-2 [&_blockquote]:border-l-2 [&_blockquote]:border-[color:var(--color-border)] [&_blockquote]:pl-3 [&_blockquote]:text-[color:var(--color-muted)]
  [&_hr]:my-4 [&_hr]:border-[color:var(--color-border)]
  [&_.trameria-table-scroll]:overflow-x-auto [&_.trameria-table-scroll]:my-3
  [&_table]:w-full [&_table]:border-collapse
  [&_th]:border-b [&_th]:border-[color:var(--color-border)] [&_th]:bg-[color:var(--color-hover)] [&_th]:px-2 [&_th]:py-1 [&_th]:text-left [&_th]:align-top [&_th]:font-semibold
  [&_td]:border-b [&_td]:border-[color:var(--color-border-soft)] [&_td]:px-2 [&_td]:py-1 [&_td]:align-top
  [&_th_p]:my-1 [&_td_p]:my-1
  [&_th+th]:border-l [&_th+th]:border-l-[color:var(--color-border-soft)]
  [&_td+td]:border-l [&_td+td]:border-l-[color:var(--color-border-soft)]`;

/**
 * The text of a document body (size, line height, links, h4, list spacing),
 * shared by the document editor and fields written in the same format (Case
 * notes). What only the document editor needs (hit areas, drag handle anchors)
 * is added by the screen.
 *
 * `pointer-coarse:text-base` keeps iOS from zooming into a focused field
 * smaller than 16px. Reference chips (`a[data-ref]`) are not dressed as links:
 * the chip has its own look.
 */
export const DOCUMENT_BODY_CLASS = `text-sm pointer-coarse:text-base leading-relaxed
  [&_a:not([data-ref])]:text-[color:var(--color-accent)] [&_a:not([data-ref])]:underline
  [&_h4]:mb-1 [&_h4]:mt-3 [&_h4]:font-semibold
  [&_li]:my-0.5
  ${MARKDOWN_BODY_CLASS}`;
